import { useIntl } from "react-intl";
import styles from "./Payment.module.scss";

export const Payment = () => {
  const intl = useIntl();

  return (
    <div className={styles.payment}>
      <div className={styles.placeholder}>
        {intl.formatMessage({ id: "payment" })}
      </div>
    </div>
  );
};
